var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewsStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4692 0.905073C8.59067 0.531208 9.11959 0.531209 9.24107 0.905074L11.0417 6.44686C11.096 6.61406 11.2518 6.72726 11.4276 6.72726H17.2546C17.6477 6.72726 17.8112 7.23029 17.4931 7.46135L12.779 10.8864C12.6368 10.9897 12.5773 11.1729 12.6316 11.3401L14.4322 16.8818C14.5537 17.2557 14.1258 17.5666 13.8078 17.3355L9.09365 13.9105C8.95143 13.8072 8.75884 13.8072 8.61661 13.9105L3.90249 17.3355C3.58446 17.5666 3.15655 17.2557 3.27803 16.8818L5.07867 11.3401C5.13299 11.1729 5.07348 10.9897 4.93125 10.8864L0.217126 7.46135C-0.100903 7.23029 0.0625427 6.72726 0.455648 6.72726H6.28263C6.45843 6.72726 6.61424 6.61406 6.66856 6.44686L8.4692 0.905073Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewsStar);
export default __webpack_public_path__ + "static/media/reviews-star.17c60fc9.svg";
export { ForwardRef as ReactComponent };